{
  "failed": "Failed",
  "moreChanges_one": "· +{{count}} more change",
  "moreChanges_other": "· +{{count}} more changes",
  "actors": {
    "system": "System"
  },
  "values": {
    "yes": "Yes",
    "no": "No"
  },
  "actions": {
    "LOGIN": "signed in",
    "LOGOUT": "signed out",
    "LOGIN_FAILED": "could not sign in",
    "PASSWORD_RESET": "reset a password",
    "PASSWORD_RESET_REQUESTED": "asked for a password reset link",
    "PASSWORD_CHANGED": "changed their password",
    "PRODUCT_CREATED": "created a product",
    "PRODUCT_UPDATED": "updated a product",
    "PRICE_CHANGED": "changed a price",
    "PRODUCT_ARCHIVED": "archived a product",
    "LOCATION_CREATED": "created a location",
    "LOCATION_UPDATED": "updated a location",
    "LOCATION_DEACTIVATED": "deactivated a location",
    "STOCK_IN": "received stock",
    "STOCK_OUT": "issued stock",
    "ADJUSTMENT": "adjusted stock",
    "OPENING_STOCK": "recorded opening stock",
    "TRANSFER_SENT": "sent a transfer",
    "TRANSFER_RECEIVED": "received a transfer",
    "TRANSFER_DIRECT": "made a direct transfer",
    "COUNT_VALIDATED": "validated an inventory count",
    "OPERATION_REVERSED": "reversed an operation",
    "NEGATIVE_STOCK_CONFIRMED": "confirmed negative stock",
    "USER_CREATED": "created a user",
    "USER_UPDATED": "updated a user",
    "USER_DEACTIVATED": "deactivated a user",
    "ROLE_CHANGED": "changed a role",
    "PERMISSION_CHANGED": "changed role permissions",
    "SETTING_CHANGED": "changed the configuration",
    "COMPANY_PROFILE_UPDATED": "updated the company profile",
    "ALERT_RAISED": "raised an alert",
    "ALERT_RESOLVED": "resolved an alert",
    "IMPORT_COMPLETED": "completed an import",
    "IMPORT_FAILED": "failed an import",
    "BACKUP_DONE": "made a backup",
    "BACKUP_FAILED": "failed a backup",
    "PRODUCT_DELETED": "deleted a product",
    "LOCATION_DELETED": "deleted a location",
    "OPERATION_CREATED": "started an operation",
    "OPERATION_CANCELLED": "discarded a draft",
    "OPERATION_SUBMITTED": "sent a correction for approval",
    "OPERATION_SENT_BACK": "sent a correction back",
    "COUNT_STARTED": "started a count",
    "COUNT_CANCELLED": "cancelled a count",
    "FILE_ATTACHED": "attached a file",
    "FILE_REMOVED": "removed a file",
    "CUSTOMER_CREATED": "created a customer",
    "CUSTOMER_UPDATED": "updated a customer",
    "CUSTOMER_MERGED": "merged two customers",
    "CUSTOMER_ANONYMIZED": "anonymized a customer",
    "CUSTOMER_DELETED": "deleted a customer",
    "FULFILLMENT_STEP": "moved an order to its next step",
    "ORDER_RETURNED": "took back items of an order",
    "ORDER_CREATED": "started an order",
    "ORDER_PLACED": "placed an order",
    "ORDER_CHANGED": "changed an order",
    "ORDER_CONFIRMED": "confirmed an order",
    "PICKING_CANCELLED": "cancelled the picking of an order",
    "ORDER_CANCELLED": "cancelled an order",
    "ORDER_COMPLETED": "completed an order",
    "RESERVATION_EXPIRED": "ended a reservation that was not paid in time",
    "PAYMENT_RECEIVED": "recorded a payment",
    "PAYMENT_VOIDED": "voided a payment",
    "PAYMENT_REFUNDED": "refunded a payment",
    "COD_SETTLED": "recorded a cash on delivery settlement",
    "DOCUMENT_ISSUED": "issued a document",
    "REGISTER_CREATED": "added a cash register",
    "REGISTER_UPDATED": "changed a cash register",
    "REGISTER_PAIRED": "paired a browser with a register",
    "REGISTER_UNPAIRED": "unpaired a register",
    "SHIFT_OPENED": "opened a shift",
    "CASH_MOVEMENT": "moved cash in a drawer",
    "SHIFT_CLOSED": "closed a shift",
    "CASH_VARIANCE_APPROVED": "approved a cash variance",
    "DRAWER_OPENED": "opened the drawer without a sale",
    "SALE_CANCELLED": "cancelled a sale at the till",
    "PAYMENT_CORRECTED": "corrected a payment at the till",
    "POS_APPROVAL_GIVEN": "allowed an action at a till",
    "REFUND_WITHOUT_RECEIPT": "took items back without a receipt",
    "ORDER_CUSTOMER_SET": "gave a ticket its customer",
    "RESTORE_DONE": "restored the data from a backup",
    "RESTORE_FAILED": "could not restore a backup",
    "SUPPLIER_CREATED": "added a supplier",
    "SUPPLIER_UPDATED": "changed a supplier",
    "SUPPLIER_PAYMENT_RECORDED": "recorded a supplier payment",
    "SUPPLIER_PAYMENT_COMPLETED": "marked a supplier payment paid",
    "SUPPLIER_PAYMENT_CANCELLED": "cancelled a supplier payment",
    "SUPPLIER_PAYMENT_ALLOCATED": "shared a supplier payment again",
    "AMOUNT_DUE_CHANGED": "changed an amount to pay",
    "PROMOTION_CREATED": "created a promotion",
    "PROMOTION_UPDATED": "changed a promotion",
    "PROMOTION_PAUSED": "paused a promotion",
    "PROMOTION_RESUMED": "resumed a promotion",
    "PROMOTION_ENDED": "ended a promotion",
    "PROMOTION_DELETED": "deleted a promotion",
    "DOCUMENT_DATE_CHANGED": "changed the date of a document"
  },
  "fields": {
    "buyQuantity": "Buy",
    "getQuantity": "Get",
    "maxSets": "At most, per sale",
    "tiers": "Quantity levels",
    "components": "Pack components",
    "target": "On what",
    "getTarget": "What it gives",
    "minQuantity": "Minimum quantity",
    "minAmount": "Minimum amount (TND)",
    "discountPercent": "Discount (%)",
    "customerTags": "Customer tags",
    "maxUses": "Uses in all",
    "maxPerCustomer": "Uses per customer",
    "saleType": "Sale type",
    "channels": "Channels",
    "startsOn": "First day",
    "endsOn": "Last day",
    "weekdays": "Days",
    "fromTime": "From",
    "toTime": "To",
    "legalName": "Legal name",
    "tradeName": "Trade name",
    "taxId": "Tax ID",
    "tradeRegisterNo": "Trade register no.",
    "address": "Address",
    "city": "City",
    "phone": "Phone",
    "email": "Email",
    "website": "Website",
    "defaultLanguage": "Default language",
    "timezone": "Time zone",
    "dateFormat": "Date format",
    "numberFormat": "Number format",
    "fiscalYearStartMonth": "Fiscal year start (month)",
    "logo": "Logo",
    "order": "Order",
    "username": "Username",
    "fullName": "Full name",
    "role": "Role",
    "language": "Language",
    "locationScope": "Location access",
    "locations": "Locations",
    "defaultLocation": "Default location",
    "status": "Status",
    "isActive": "Active",
    "name": "Name",
    "symbol": "Symbol",
    "decimals": "Decimals",
    "direction": "Direction",
    "parentId": "Parent",
    "prefix": "Prefix",
    "negativeStockPolicy": "Negative stock",
    "quickTransfersEnabled": "Quick transfers",
    "adjustmentApprovalThreshold": "Approval threshold (TND)",
    "deadStockDays": "Dead stock (days)",
    "transferLateDays": "Late transfer (days)",
    "countVarianceAlertPercent": "Count difference (%)",
    "dailyDigestTime": "Daily summary time",
    "enabledLanguages": "Enabled languages",
    "added": "Permissions added",
    "removed": "Permissions removed",
    "failedAttempt": "Attempt",
    "sku": "SKU",
    "barcode": "Barcode",
    "description": "Description",
    "category": "Category",
    "brand": "Brand",
    "unit": "Unit",
    "minStock": "Minimum stock",
    "maxStock": "Maximum stock",
    "locationThresholds": "Limits per location",
    "costPrice": "Reference cost price",
    "sellingPrice": "Selling price",
    "photo": "Photo",
    "code": "Code",
    "type": "Type",
    "responsible": "Responsible",
    "responsibleUserId": "Responsible",
    "site": "Site",
    "error": "Error",
    "created": "Products created",
    "updated": "Products updated",
    "categoriesCreated": "Categories created",
    "brandsCreated": "Brands created",
    "location": "Location",
    "lines": "Lines",
    "outType": "Type of issue",
    "reason": "Reason",
    "partner": "From / to",
    "externalReference": "Their reference",
    "size": "Size (bytes)",
    "documents": "Records",
    "operation": "Operation",
    "note": "Note",
    "value": "Value (TND)",
    "from": "From",
    "to": "To",
    "corrections": "Corrections",
    "adjustment": "Adjustment",
    "count": "Count",
    "transfer": "Transfer",
    "quantity": "Quantity",
    "min": "Minimum",
    "max": "Maximum",
    "days": "Days",
    "limit": "Limit",
    "percent": "Difference (%)",
    "elsewhere": "Elsewhere",
    "alertEmails": "Alert emails",
    "dailySummary": "Daily summary email",
    "attachment": "Attachment",
    "taxRate": "VAT rate",
    "listPrices": "Other prices",
    "rate": "Rate",
    "defaultRate": "Default rate",
    "priceList": "Price list",
    "paymentMethods": "Payment methods",
    "documentPrefix": "Order prefix",
    "fulfillmentSite": "Fulfillment site",
    "pickupSites": "Pickup sites",
    "deliveryModes": "Delivery",
    "steps": "Preparation steps",
    "reservationMinutes": "Stock reservation (min)",
    "personalDetails": "Personal details",
    "mergedFrom": "Merged from",
    "contactName": "Contact",
    "addresses": "Addresses",
    "notes": "Notes",
    "tags": "Tags",
    "marketingConsent": "Agrees to marketing",
    "step": "Step",
    "carrier": "Carrier",
    "defaultCarrier": "Default carrier",
    "labels": "Barcode labels",
    "image": "Photo",
    "trackingNumber": "Tracking number",
    "trackingUrl": "Tracking link",
    "cashOnDelivery": "Collects cash on delivery",
    "reservedUntil": "Reserved until",
    "reserved": "Reserved",
    "total": "Total (TND)",
    "returnDays": "Return period (days)",
    "amount": "Amount",
    "method": "Method",
    "reference": "Reference",
    "document": "Document",
    "orders": "Orders",
    "siteId": "Site",
    "receiptPrefix": "Receipt prefix",
    "device": "Device",
    "float": "Opening float",
    "expectedFloat": "Float left by the previous shift",
    "movementType": "Movement",
    "counted": "Counted",
    "expected": "Expected",
    "variance": "Variance",
    "onlinePublished": "Sold online",
    "onlineTitle": "Online title",
    "onlineSlug": "Online address",
    "onlineSortOrder": "Online order",
    "onlineDescription": "Online description",
    "gallery": "Online photos",
    "shippingFee": "Shipping fee",
    "storeOrigins": "Storefront websites",
    "stampDuty": "Stamp duty",
    "codSettlementDays": "Cash on delivery settlement days",
    "cashDenominations": "Notes and coins",
    "cashVarianceLimit": "Cash variance limit",
    "shiftCloseTime": "Shift closing time",
    "blindCloseCount": "Blind closing count",
    "posDiscountLimitPercent": "Cashier discount limit",
    "favorites": "Favourites",
    "onSale": "On sale",
    "shownOnline": "Shown online",
    "slug": "Address",
    "placement": "Where it shows",
    "text": "Text",
    "action": "Button",
    "linkType": "Opens",
    "linkTarget": "Link",
    "backgroundColor": "Background colour",
    "textColor": "Text colour",
    "homeSections": "Home page blocks",
    "approvedBy": "Approved by",
    "permission": "Permission",
    "register": "Register",
    "partial": "Partly restored",
    "payee": "Paid to",
    "allocations": "Receipts paid",
    "completedOn": "Paid on",
    "amountDue": "Amount to pay",
    "dueDate": "Due date",
    "receivedOn": "Received on",
    "documentDate": "Document date",
    "documentPrint": "Hidden on printed documents"
  },
  "notes": {
    "created": "Value created",
    "updated": "Value updated",
    "activated": "Value activated",
    "deactivated": "Value deactivated",
    "deleted": "Value deleted",
    "reactivated": "Reactivated",
    "seed": "Created at installation",
    "system_location": "System location created",
    "by_admin": "Reset by an administrator",
    "via_email_link": "Reset with the emailed link",
    "self_service": "Changed by the user",
    "first_sign_in": "Chosen at the first sign-in",
    "own_profile": "Own profile",
    "wrong_password": "Wrong password",
    "wrong_password_locked": "Wrong password, account locked",
    "unknown_user": "Unknown username",
    "account_locked": "Account locked",
    "account_deactivated": "Account deactivated",
    "wrong_current_password": "Wrong current password",
    "email_sent": "Link sent by email",
    "no_matching_account": "No matching account",
    "no_email_on_account": "No email on the account",
    "restored": "Restored from the archive",
    "import": "Imported from a file",
    "location_access": "Access to a site changed",
    "with_site": "Closed with its site",
    "check_failed": "The file could not be checked",
    "import_failed": "The import stopped",
    "above_threshold": "Above the approval limit",
    "approved": "Approved by a manager",
    "negative_blocked": "Refused: negative stock is blocked",
    "negative_not_allowed": "Refused: not allowed to confirm negative stock",
    "entered_twice": "Entered twice by mistake",
    "wrong_quantity": "Wrong quantity",
    "wrong_product": "Wrong product",
    "wrong_location": "Wrong location",
    "wrong_cost": "Wrong cost",
    "other": "Other reason",
    "manual": "Manual backup",
    "automatic": "Automatic backup",
    "closed_with_difference": "Closed with a difference",
    "more_to_come": "More will come",
    "from_count": "Count correction",
    "from_transfer": "Transit loss",
    "negative_stock": "Negative stock",
    "large_adjustment": "Large adjustment",
    "low_stock": "Low stock",
    "transfer_delayed": "Transfer delayed",
    "out_of_stock": "Out of stock",
    "count_variance": "Count variance",
    "overstock": "Overstock",
    "job_failed": "Import or backup failed",
    "cleared": "The problem was fixed",
    "read": "Closed when read",
    "decided": "The document was decided",
    "next_success": "The next run succeeded",
    "new_permissions": "New permissions of this version",
    "note_added": "Note added",
    "request_added": "Request added",
    "sign_up": "Signed up online",
    "guest_checkout": "Ordered as a guest",
    "password_link": "Password link created",
    "customerRequest": "At the customer’s request",
    "outOfStock": "Out of stock",
    "paymentFailed": "Payment failed",
    "duplicate": "Entered twice",
    "reservationExpired": "Not paid in time",
    "changedMind": "Changed their mind",
    "defective": "Defective",
    "wrongItem": "Wrong item",
    "damaged": "Damaged",
    "pos": "At the counter",
    "online": "Online store",
    "backOffice": "Back office",
    "cod_settlement": "Paid in by the courier",
    "invoice": "Invoice",
    "creditNote": "Credit note",
    "receipt": "Receipt",
    "test": "Test payment provider",
    "overpaid": "The provider took more than the order owed",
    "pendingApproval": "Waits for a manager to approve the variance",
    "order_to_prepare": "Order to prepare",
    "cod_overdue": "Cash on delivery not settled",
    "shift_open_late": "Shift still open",
    "cash_variance": "Cash variance to approve",
    "confirmed_duplicate": "recorded although a similar payment exists",
    "goods_value": "back to the goods value"
  },
  "title": "Activity log",
  "readOnly": "Read-only",
  "subtitle": "Every action by a person or by the system. Nobody can change or delete these records, not even an admin.",
  "export": "Export to Excel",
  "families": {
    "authentication": "Sign-ins",
    "masterData": "Products and locations",
    "stock": "Stock",
    "usersAndConfiguration": "Users and settings",
    "sales": "Sales and customers",
    "purchases": "Suppliers",
    "promotions": "Promotions",
    "system": "System"
  },
  "tabs": {
    "all": "All actions",
    "movements": "Stock movements",
    "signIns": "Sign-ins",
    "settings": "Settings & users"
  },
  "filters": {
    "search": "Reference, product or TX number",
    "date": "Date",
    "periods": {
      "today": "Today",
      "yesterday": "Yesterday",
      "7d": "Last 7 days",
      "30d": "Last 30 days",
      "any": "Any date"
    },
    "who": "Who",
    "everyone": "Everyone",
    "action": "Action",
    "operationType": "Operation",
    "allTypes": "All types",
    "location": "Location",
    "allLocations": "All locations"
  },
  "columns": {
    "time": "Time",
    "who": "Who",
    "what": "What happened",
    "reference": "Reference"
  },
  "ledger": {
    "when": "When",
    "document": "Document",
    "product": "Product",
    "location": "Location",
    "change": "Change",
    "unitCost": "Unit cost",
    "balanceAfter": "Balance after",
    "by": "By",
    "reversal": "reversal",
    "negative": "Negative"
  },
  "detail": {
    "title": "Record",
    "pick": "Pick a line to see its details: before and after values, the movements it wrote, the device.",
    "when": "{{when}}",
    "before": "Before",
    "after": "After",
    "actionType": "Action type",
    "target": "About",
    "reference": "Reference",
    "result": "Result",
    "success": "Success",
    "note": "Note",
    "device": "Device",
    "ip": "IP address",
    "movements_one": "{{count}} stock movement",
    "movements_other": "{{count}} stock movements",
    "openOperation": "Open {{number}}",
    "open": "Open"
  },
  "empty": "Nothing recorded with these filters.",
  "showing_one": "Showing {{count}} record",
  "showing_other": "Showing {{count}} records",
  "loadMore": "Load more"
}
